import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js';
import store from './vuex/store';
import ProgressBar from 'vuejs-progress-bar'
import './common/icon/style.css';
Vue.use(ProgressBar)
Vue.config.productionTip = false

new Vue({
    data: {
        Bus: new Vue()
    },
    store,
    router,
    render: h => h(App),
}).$mount('#app')